import React from "react"
import type { Answers, QuestionDef } from "../types/questions"

interface QuestionStepProps {
  question: QuestionDef
  answers: Answers
  onSelect: (questionId: string, value: string) => void
}

export function QuestionStep({
  question,
  answers,
  onSelect,
}: QuestionStepProps): JSX.Element {
  const selectedValue = answers[question.id]

  return (
    <section className="csw-step-main" aria-live="polite">
      <h2 className="csw-question-title @max-5xl:text-[clamp(30px,8vw,40px)] @max-5xl:font-medium @max-5xl:max-w-none">
        {question.label}
      </h2>
      <p className="csw-question-subtitle">{question.subtitle}</p>

      <div
        className="csw-options"
        role="radiogroup"
        aria-label={question.label}
      >
        {question.options.map((option) => {
          const checked = selectedValue === option.value
          return (
            <label
              key={`${question.id}-${option.value}`}
              className={`csw-option @max-5xl:text-base ${checked ? "is-selected" : ""}`}
            >
              <input
                type="radio"
                name={question.id}
                checked={checked}
                onChange={() => onSelect(question.id, option.value)}
              />
              <span className="@max-5xl:text-base">{option.label}</span>
            </label>
          )
        })}
      </div>
    </section>
  )
}
